import type { ReactNode } from 'react';
import { PeriodFreshnessHint } from '@/presentation/components/common/PeriodFreshnessHint';

interface DomainPageHeaderProps {
  title: string;
  subtitle?: string;
  question?: string;
  children?: ReactNode;
}

/** Cabecera de dominio: pregunta de negocio + título + acciones/filtros. */
export function DomainPageHeader({ title, subtitle, question, children }: DomainPageHeaderProps) {
  return (
    <header className="bi-domain-header flex flex-wrap items-start justify-between gap-4">
      <div className="min-w-0 space-y-1">
        {question && (
          <p className="text-[11px] font-semibold uppercase tracking-[0.14em] text-teal-700 dark:text-teal-400">
            {question}
          </p>
        )}
        <h1 className="text-xl font-semibold tracking-tight text-gray-950 dark:text-white sm:text-2xl">{title}</h1>
        {subtitle && <p className="max-w-2xl text-sm text-gray-600 dark:text-gray-400">{subtitle}</p>}
        <PeriodFreshnessHint placement="page" />
      </div>
      {children ? <div className="shrink-0">{children}</div> : null}
    </header>
  );
}
